import { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as CloseIcon } from 'assets/close-icon.svg';
import i18nContext from 'components/i18n-context';
import { getErrorMessageForAlert } from 'services/utils';
import Button from 'uikit/Button/Button';
import Input from 'uikit/Input/Input';
import Alert from 'uikit/Alert/Alert';
import '../PopUpScheme/PopUpScheme.scss';

const ShareAccountModal = ({ isLoading, onClose, onConfirm, error, clearError }) => {
  const i18n = useContext(i18nContext);
  const [customerId, setCustomerId] = useState('');
  const [inputError, setInputError] = useState('');

  const handleCustomerIdChange = (e) => {
    const value = e.target.value;

    // Clear errors on change
    setInputError('');
    if (error) {
      clearError();
    }

    // Validate max length
    if (value.length > 16) {
      setInputError(i18n.getMessage('accountDetails.shareModal.error.maxLength'));
      return;
    }

    setCustomerId(value);
  };

  const handleConfirm = () => {
    // Validate input
    if (!customerId.trim()) {
      setInputError(i18n.getMessage('accountDetails.shareModal.error.invalidCustomerId'));
      return;
    }

    if (customerId.length > 16) {
      setInputError(i18n.getMessage('accountDetails.shareModal.error.maxLength'));
      return;
    }

    onConfirm(customerId.trim());
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !isLoading && customerId.trim() && !inputError) {
      handleConfirm();
    }
  };

  return (
    <div className='scheme-wrapper share-account'>
      <div className='scheme-header'>
        <p className='title'>{i18n.getMessage('accountDetails.shareModal.title')}</p>
        <CloseIcon className='scheme-close-icon' onClick={onClose} />
      </div>

      <div className={'scheme-content'}>
        <p className={'description-text'}>{i18n.getMessage('accountDetails.shareModal.description')}</p>

        <Input
          className='customer-id-input'
          type='text'
          label={i18n.getMessage('accountDetails.shareModal.customerIdLabel')}
          placeholder={i18n.getMessage('accountDetails.shareModal.customerIdPlaceholder')}
          value={customerId}
          onChange={handleCustomerIdChange}
          onKeyPress={handleKeyPress}
          isDisabled={isLoading}
          error={inputError}
          max={16}
          autoFocus={true}
          isRequired={true}
        />

        {error && !inputError && <Alert type='warning' className='share-account-error-alert' message={error} />}
      </div>

      <div className='scheme-footer'>
        <Button
          className='confirm-button'
          type='primary'
          size='large'
          isLoading={isLoading}
          onClick={handleConfirm}
          isDisabled={isLoading || !customerId.trim() || !!inputError}
        >
          {i18n.getMessage('accountDetails.shareModal.confirmButton')}
        </Button>
      </div>
    </div>
  );
};

ShareAccountModal.propTypes = {
  isLoading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  error: PropTypes.any,
  clearError: PropTypes.func
};

export default ShareAccountModal;
